import { render, staticRenderFns } from "./ReportingPreferencesStep.vue?vue&type=template&id=a6da9bda&scoped=true"
import script from "./ReportingPreferencesStep.vue?vue&type=script&lang=js"
export * from "./ReportingPreferencesStep.vue?vue&type=script&lang=js"
import style0 from "./ReportingPreferencesStep.vue?vue&type=style&index=0&id=a6da9bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6da9bda",
  null
  
)

export default component.exports